import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Moment from 'moment';
import { Link } from 'react-router';
import ReactTooltip from 'react-tooltip';
import { linkTo } from 'helpers/url';
import { DISPLAY_DATE } from 'config/constants';
import S from 'calendar.scss';

const CalendarPTO = ({ date, assignee, pto, availabilityArgs, disablePto }) => {
  const tooltipId = pto ? pto.id : `${date.clone().format(DISPLAY_DATE)}-${assignee.id}`;

  const tooltipReason = () => {
    const reasonArr = [`Check ${assignee.kind} Availability/Time Off`];
    if (pto && (pto.reason || null)) reasonArr.unshift(pto.reason);
    return reasonArr.join('--');
  };

  const hasDay = (when = '') => {
    const start = date.startOf('day');
    if (when === 'after') {
      return ((pto && !start.isSame(Moment(pto.end_date)))
        || (availabilityArgs && availabilityArgs.unavailableAfter));
    }
    return ((pto && !start.isSame(Moment(pto.start_date)))
      || (availabilityArgs && availabilityArgs.unavailableBefore));
  };

  return (
    <article
      data-tip data-for={`pto-${tooltipId}`}
      className={cx(S.pto, {
        [S.hasNextDay]: hasDay('after'),
        [S.hasPreviousDay]: hasDay(),
      })}
      style={{ position: 'relative' }}
    >
      {(availabilityArgs || (pto && pto.reason)) && <ReactTooltip
        id={`pto-${tooltipId}`} place="top" effect="solid"
      ><span>{tooltipReason()}</span></ReactTooltip>}
      <Link to={linkTo(assignee)} className={S.link}>
        Unavailable
      </Link>
      {disablePto && (<div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 2,
          background: 'transparent',
          pointerEvents: 'all',
        }}
      />)}
    </article>
  );
};

CalendarPTO.defaultProps = { disablePto: false };

CalendarPTO.propTypes = {
  date: PropTypes.instanceOf(Moment).isRequired,
  assignee: PropTypes.shape({
    id: PropTypes.number.isRequired,
    kind: PropTypes.oneOf(['Estimator', 'Crew', 'IQM']).isRequired,
  }).isRequired,
  pto: PropTypes.shape({
    id: PropTypes.number.isRequired,
    start_date: PropTypes.string.isRequired,
    end_date: PropTypes.string.isRequired,
    reason: PropTypes.string,
  }).isRequired,
  availabilityArgs: PropTypes.bool,
  disablePto: PropTypes.bool,
};

export default CalendarPTO;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/calendarPTO.jsx